export default __webpack_public_path__ + "static/media/tick-icon.b91012d1.svg";